<template>
  <div class="wb-list-group emh-side-filters-categories">
    <div
      v-for="category in filterCategories"
      :key="category.code"
      class="emh-side-filters-categories__item"
      :class="{
        '-disabled': isLoading,
      }"
      :data-test-id="`emh-side-filters-categories__item__${category.code}`"
      @click="selectCategory(category.code)"
    >
      <emh-side-filters-category-head :category="category"></emh-side-filters-category-head>
      <wb-icon class="emh-side-filters-categories__icon" :name.attr="'bds/chevron-right/16'"></wb-icon>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'EmhSideFiltersCategories',
};
</script>

<script lang="ts" setup>
import { PropType } from 'vue';
import { IProductFilterGroup } from '@dh-io-emh/shared/src/models/product-filter/product-filter-base.model';
import EmhSideFiltersCategoryHead from './sideFiltersCategoryHead/sideFiltersCategoryHead.vue';

defineProps({
  isLoading: {
    type: Boolean,
    required: true,
  },
  filterCategories: {
    type: Array as PropType<IProductFilterGroup[]>,
    default: () => [],
  },
});

const emit = defineEmits(['select-category']);

const selectCategory = (category: string) => {
  emit('select-category', category);
};
</script>

<style lang="scss" scoped>
.emh-side-filters-categories {
  border: none;

  &__item {
    border-bottom: 1px solid var(--wb-grey-85);
    color: var(--color);
    display: flex;
    font-family: var(--wb-font-text);
    font-size: 1rem;
    line-height: 1.25rem;
    outline: none;
    padding-top: var(--wb-spacing-xs);
    padding-bottom: var(--wb-spacing-xs);
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    gap: var(--wb-spacing-xs);

    &:hover {
      margin: -1px -1px 0;
      border: 1px solid var(--wb-grey-80);
      background: var(--wb-grey-90);
      border-radius: var(--wb-radius-s);
      transition: background-color 0.3s ease-in-out;
    }
  }

  &__icon {
    flex-shrink: 0;
    margin: 0 var(--wb-spacing-xxs);
  }

  .emh-side-filters-categories__item {
    &.-disabled {
      opacity: 0.3;
      pointer-events: none;
    }
  }
}
</style>
